import { c as _c } from "react/compiler-runtime";
import { ArrowDown01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { cn } from "@matsuricon/ui/utils";
import { useId, useState } from "react";
import { MobileLeafLink } from "./mobile-leaf-link";
import { mobileDepthClass } from "./mobile-nav-styles";
import { isNavGroup, type NavGroup } from "./navigation-data";
import { containsCurrentPath } from "./navigation-utils";
type MobileDisclosureProps = {
  group: NavGroup;
  depth: number;
  pathname: string;
  onNavigate: () => void;
};
export function MobileDisclosure(t0) {
  const $ = _c(42);
  const {
    group,
    depth,
    pathname,
    onNavigate
  } = t0;
  const [open, setOpen] = useState(false);
  const regionId = useId();
  let t1;
  if ($[0] !== group || $[1] !== pathname) {
    t1 = containsCurrentPath(group, pathname);
    $[0] = group;
    $[1] = pathname;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const active = t1;
  let t2;
  if ($[3] !== active || $[4] !== depth) {
    t2 = cn("flex min-h-11 w-full items-center gap-2 rounded-md pr-3 text-left font-sans text-sm font-semibold tracking-normal transition-[background-color,color] hover:bg-muted hover:text-foreground", mobileDepthClass(depth), active ? "text-primary" : "text-foreground");
    $[3] = active;
    $[4] = depth;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setOpen(_temp);
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== group.label) {
    t4 = <span className="min-w-0 flex-1">{group.label}</span>;
    $[7] = group.label;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = open && "rotate-180";
  let t6;
  if ($[9] !== t5) {
    t6 = cn("transition-transform duration-200", t5);
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <HugeiconsIcon aria-hidden="true" icon={ArrowDown01Icon} strokeWidth={2} className={t6} />;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== open || $[14] !== regionId || $[15] !== t2 || $[16] !== t4 || $[17] !== t7) {
    t8 = <button type="button" aria-controls={regionId} aria-expanded={open} className={t2} onClick={t3}>{t4}{t7}</button>;
    $[13] = open;
    $[14] = regionId;
    $[15] = t2;
    $[16] = t4;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const t9 = !open;
  let t10;
  if ($[19] !== depth || $[20] !== group.href || $[21] !== group.label || $[22] !== onNavigate || $[23] !== pathname) {
    t10 = group.href ? <li><MobileLeafLink item={{
        label: `Explore ${group.label}`,
        href: group.href
      }} depth={depth + 1} pathname={pathname} onNavigate={onNavigate} /></li> : null;
    $[19] = depth;
    $[20] = group.href;
    $[21] = group.label;
    $[22] = onNavigate;
    $[23] = pathname;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== depth || $[26] !== group.children || $[27] !== onNavigate || $[28] !== pathname) {
    let t12;
    if ($[30] !== depth || $[31] !== onNavigate || $[32] !== pathname) {
      t12 = item => isNavGroup(item) ? <MobileDisclosure key={item.label} group={item} depth={depth + 1} pathname={pathname} onNavigate={onNavigate} /> : <li key={item.href}><MobileLeafLink item={item} depth={depth + 1} pathname={pathname} onNavigate={onNavigate} /></li>;
      $[30] = depth;
      $[31] = onNavigate;
      $[32] = pathname;
      $[33] = t12;
    } else {
      t12 = $[33];
    }
    t11 = group.children.map(t12);
    $[25] = depth;
    $[26] = group.children;
    $[27] = onNavigate;
    $[28] = pathname;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[34] !== regionId || $[35] !== t10 || $[36] !== t11 || $[37] !== t9) {
    t12 = <ul id={regionId} hidden={t9} className="grid gap-1 py-1">{t10}{t11}</ul>;
    $[34] = regionId;
    $[35] = t10;
    $[36] = t11;
    $[37] = t9;
    $[38] = t12;
  } else {
    t12 = $[38];
  }
  let t13;
  if ($[39] !== t12 || $[40] !== t8) {
    t13 = <li>{t8}{t12}</li>;
    $[39] = t12;
    $[40] = t8;
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  return t13;
}
function _temp(value) {
  return !value;
}